import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { closeStationery } from "./closeStationery";
import { pxPerInch } from "../../../../data/stationery";

export const saveStationery = async (actives: stdObject, params: stdObject) => {
  const {
    t,
    customUpdate,
    staValues,
    closeMsg,
    setMsg3,
    setModalData3,
    setStaValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    logoutAction,
  } = params;
  let staMsg =
    staValues.data.NOMDOC.trim() === ""
      ? "enterAName"
      : staValues.data.ANCDOC < pxPerInch
        ? "incorrectPageWidth"
        : staValues.data.ALTDOC < pxPerInch
          ? "incorrectPageHeight"
          : false;
  if (staMsg) {
    setMsg3("custom3");
    setModalData3({
      code: "warning",
      title: t(`p.${staMsg}`),
    });
  } else {
    setMsg3("loading");
    const payloadSaveStationery = {
      data: staValues.data,
      parts: staValues.parts.filter((e: stdObject) => actives[e.NUMPAR]),
    };
    console.log("payloadSaveStationery", payloadSaveStationery);
    const responseSaveStationery: stdObject = await sendData({
      endPoint: "saveStationery",
      payload: payloadSaveStationery,
      logoutAction,
    });
    console.log(
      "responseSaveStationery",
      responseSaveStationery,
      Object.keys(responseSaveStationery)
        .map((e) => responseSaveStationery[e])
        .join(""),
    );
    if (responseSaveStationery.success && responseSaveStationery.status) {
      customUpdate.current = {
        stationeryInfo: staValues.index,
        info: responseSaveStationery.info[0],
      };
      closeMsg(3);
      closeStationery(true, {
        staValues,
        setStaValues,
        setStationeryModal,
        setMsg,
        documentAction,
        openWindow,
        closeMsg,
      });
    } else {
      setMsg3("error");
    }
    return;
  }
};
